import axios from 'axios'

export default {
    state: {
        categories: null,
        loading: {
            categories: true
        }
    },
    getters: {
        publicCategories: state => state.categories,
        publicCategoriesLoading: state => state.loading
    },
    mutations: {
        SET_CATEGORIES(state, categories) {
            state.categories = categories
        },
        START_LOADING_CATEGORIES(state) {
            state.loading.categories = true
        },
        FINISH_LOADING_CATEGORIES(state) {
            state.loading.categories = false
        }
    },
    actions: {
        async getPublicCategories({ commit }) {
            commit('START_LOADING_CATEGORIES')

            const url = '/public/dict/categories?sort_by=Position'

            try {
                const resp = await this.$axios.get(url)

                commit('SET_CATEGORIES', resp.data)
            } finally {
                commit('FINISH_LOADING_CATEGORIES')
            }
        }
    }
}
